<!-- NOTCH SUPPORT!! https://blog.phonegap.com/displaying-a-phonegap-app-correctly-on-the-iphone-x-c4a85664c493 -->
<!-- ios xcode device support https://github.com/JinjunHan/iOSDeviceSupport -->

<template>
  <div id="app">
    
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
     
    <toaster/>

    <drawer-menu>

      <div class="drawer-scroll">
      <page-padding>
        
        <p><b>
          <catch-link v-if="computeSchoolUrl" :href="computeSchoolUrl" target="_blank">{{computeSchoolUrl}}</catch-link>
        </b></p>

        <div v-if="debug">
          user level={{appSettings.user_level}}
        
          <div>parent : {{USER_LEVEL.PARENT}}</div>
          <div>teacher : {{USER_LEVEL.TEACHER}}</div>
          <div>admin : {{USER_LEVEL.ADMIN}}</div>
          <div>student : {{USER_LEVEL.STUDENT}}</div>
        </div>
        

        <user-info/>

       

        <drawer-divider title="language.divider_above_groups">
          <drawer-link v-if="appSettings.modules.teacher_talks=='1' && appSettings.user_level!=USER_LEVEL.STUDENT" to="/talks/" title="language.page_parentspeak"/>
          <drawer-link v-if="appSettings.modules.chat=='1' && appSettings.user_level!=USER_LEVEL.STUDENT" to="/chatpersons" title="language.page_chatpersons"/>
          <drawer-link to="/group/0/globalnews/init" title="language.page_news"/>
          <drawer-link v-if="appSettings.modules.calendar=='1'" to="/calendar" title="language.page_calendar"/>
          <drawer-link v-if="appSettings.modules.pictures=='1'" to="/albums" title="language.page_albums"/>
          <drawer-link v-if="appSettings.modules.newsletters=='1'" to="/newsletters" title="language.page_newsletters"/>
          <drawer-link v-if="appSettings.modules.documents=='1'" to="/documents" title="language.page_documents"/>
          <drawer-link v-if="appSettings.modules.absences=='1'" to="/group/0/absences" title="language.divider_callsick"/>
          <drawer-link to="/pushnotes" title="language.page_pushnotes"/>
          <!--<drawer-link v-if="appSettings.user_type=='admin'" to="/watson_assistant" title="language.watson_assistant"/>-->
        </drawer-divider>

        
        <drawer-divider title="language.divider_group_messages">
          <drawer-link v-for="(group, index) in groups" :key="index" :to="'/group/'+group.id+'/news/init'" :title="group.name"/>
        </drawer-divider>

        <!--
        <drawer-divider title="language.divider_teachers">
          <drawer-link to="/xxx" title="language.page_absence"/>
          <drawer-link to="/xxx" title="language.page_parentspeak"/>
        </drawer-divider>
        -->

        <drawer-divider title="language.divider_other">
          <drawer-link to="/settings" title="language.page_settings"/>
           <drawer-link to="/support" title="language.page_support"/>
          <drawer-link to="/contact" title="language.page_contact"/>
        </drawer-divider>
       
      </page-padding>
      </div>
    </drawer-menu>

  </div>
</template>

<script>


import DrawerMenu from './components/DrawerMenu.vue'
import DrawerLink from './components/buttons/DrawerLink.vue'
import DrawerDivider from './components/dividers/DrawerDivider.vue'
import { mapState } from 'vuex';
import { USER_LEVEL } from './settings/USER_LEVEL.js';
import PagePadding from './components/PagePadding.vue';
import Toaster from './components/toast/Toaster.vue';
//import { helper } from './services/Helper.js';
//import { modalService } from './services/ModalService.js';
//import i18n from "./language.js";
import { history } from './services/History.js';
import UserInfo from './components/UserInfo.vue';
import { apiDocumenter } from './services/ApiDocumenter.js';
import CatchLink from './components/CatchLink.vue';
import Vue from 'vue';



export default {
  name: 'app',
  data(){
    return {
      USER_LEVEL:USER_LEVEL,
      animate:false,
      tooOld:false,
    }
  },
  components: {
    DrawerMenu,
    DrawerLink,
    PagePadding,
    DrawerDivider,
    Toaster,
    UserInfo,
    CatchLink,
  },
  computed:{
     ...mapState(['groups','appSettings','user_language','user_stored','debug','caroussel_fullscreen','user_schools']),
     computeSchoolUrl(){
       return this.appSettings.school_app_website ? this.appSettings.school_app_website : "";
     }
     
  },
  methods:{
    
    backButtonAndroid(){
      if(!this.caroussel_fullscreen){
        this.$router.push(history.get());
      }
    },
  },
  created(){

  },
  updated(){
   
    
  },
  beforeDestroy(){
    // android backbutton support
    document.removeEventListener("backbutton", this.backButtonAndroid);
  },
  mounted(){
   

    this.animate=true;

    // init api documenter
    apiDocumenter.init(this.debug);

    // setting the language
    this.$i18n.locale = this.user_stored.language;
    
    // android backbutton support
    document.addEventListener("backbutton", this.backButtonAndroid, false);


    // check standalone
    const isInWebAppiOS = (window.navigator.standalone === true);
    const isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches);
    
    if(!isInWebAppiOS && !isInWebAppChrome){
      Vue.$toaster.toast('Deze webapp kan worden geinstalleerd voor Android en iOS.'); 
    }
    
  }
}
</script>
<style scoped>

</style>
<style>
*{
  
  box-sizing:border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-user-select: none; 
  -moz-user-select: none;    
  -ms-user-select: none;    
  user-select: none;      
  -webkit-tap-highlight-color: transparent;
}
a{
  color:#50C0DB;
}

input, textArea{
  -webkit-user-select: auto!important; /* Chrome all / Safari all */
  -moz-user-select: auto!important;    /* Firefox all             */
  -ms-user-select: auto!important;     /* IE 10+                  */
  user-select: auto!important;        /* Likely future   */
  font-family: inherit;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

html{
  /*touch-action: manipulation;*/
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family:'Font-Regular';

}

/* lets show scrollbars on android... */
/*
html ::-webkit-scrollbar {width: 4px; border:1px solid green; padding:10px; background: rgba(255,0,0,0);}
html ::-webkit-scrollbar-track { background: rgba(255,0,0,0);}
html ::-webkit-scrollbar-thumb { border-radius: 0px; background: rgb(120,120,120,0); }
html ::-webkit-scrollbar-thumb:window-inactive {background: rgb(128,128,128); }
*/

body{
 margin: 0;
 padding: 0;
 overflow:hidden!important;
 overflow-x:hidden!important;
 overflow-y:hidden!important;

 /* notch support ios */
 
  padding-top: constant(safe-area-inset-top); /* iOS 11.0 */
  padding-top: env(safe-area-inset-top);  /* iOS 11.2 */
  padding-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
  padding-bottom: env(safe-area-inset-bottom); /* iOS 11.2 */
  

}

/* fixing things dropping off */
#app{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;

}


iframe{
  height:100%;
  width:100%;
}

.drawer-scroll{
  width:100%;
  height:100%;
  overflow:hidden;
  overflow-y:scroll;
  -webkit-overflow-scrolling: touch;
}


.fade-enter-active, .fade-leave-active {
 transition: transform .25s, opacity .25s;
}
.fade-enter, .fade-leave-active{
  opacity: 0;
  transform:scale(.98);
}


.drawer-menu .router-link-exact-active{
  font-size:2em;
  color:#FFFFFF;
}


/* font family */

@font-face {
    font-family: 'Font-Light';
    src: url('assets/Roboto-Light.ttf')  format('truetype')
}
@font-face {
    font-family: 'Font-Regular';
    src: url('assets/Roboto-Regular.ttf')  format('truetype')
}
@font-face {
    font-family: 'Font-Bold';
    src: url('assets/Roboto-Bold.ttf')  format('truetype')
}

</style>


